















































































































































































































































import gql from 'graphql-tag';
import { v4 as uuid } from 'uuid';
import Component from 'vue-class-component';

import DataApiManager from '@/api/dataApiManager';
import { Wallet } from '@/api-svc-types';
import { BaseVue } from '@/BaseVue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import { stringifyError } from '@/utils/error';
import { getEmptyStringProps } from '@/utils/stringUtils';

import { upload } from '../../services/fileUploadService';
import { downloadCsv } from '../data/dataUtils';
import UiButton from '../ui/UiButton.vue';
import UiDatePicker from '../ui/UiDatePicker.vue';
import UiLoading from '../ui/UiLoading.vue';
import UiModal from '../ui/UiModal.vue';
import UiSelect2 from '../ui/UiSelect2.vue';
import UiTextEdit from '../ui/UiTextEdit.vue';
import CategorizeJob from './CategorizeJob.vue';
import MetadataConditionInput, { MetadataConditionValue } from './MetadataConditionInput.vue';

@Component({
  components: {
    UiCheckbox,
    UiSelect2,
    UiDatePicker,
    UiButton,
    UiLoading,
    UiModal,
    UiTextEdit,
    CategorizeJob,
    MetadataConditionInput,
  },
})
export default class RunJob extends BaseVue {
  public actions = [
    { label: 'Delete Transactions', id: 'delete' },
    { label: 'Ignore Transactions', id: 'ignore' },
    { label: 'Mark Transactions as Reconciled', id: 'markReconciled' },
    { label: 'Reconcile Transactions', id: 'reconcile' },
    { label: 'Categorize Transactions', id: 'categorize' },
    { label: 'Uncategorize Transactions', id: 'uncategorize' },
    { label: 'Unignore Transactions', id: 'unignore' },
    { label: 'Unreconcile Transactions', id: 'markUnreconciled' },
    { label: 'CSV Bulk Action', id: 'csvBulkAction' },
    { label: 'Re-price Failed-to-Price Transactions', id: 'repriceFailedToPriceTransactions' },
    { label: 'Re-price Priced and Ready-to-Price Transactions', id: 'repricePricedAndReadyToPriceTransactions' },
    { label: 'Process Needs-Review Transactions', id: 'processNeedsReviewTransactions' },
    { label: 'Reprocess Rollup Parent Transactions', id: 'reprocessRollupParentTxns' },
  ];

  public newDataSourceSchema: { id: string; name: string } | null = null;
  public isCreatingDataSource = false;
  public newDataSourceName = '';

  public async createDataSource() {
    this.isCreatingDataSource = true;
    try {
      const ds = DataApiManager.getInstance();
      const res = await ds.createDataSources(
        this.orgId,
        { name: this.newDataSourceName, schemaId: 'bulk-action-txns', params: null },
        { withCredentials: true }
      );
      if (res.status === 200) {
        this.showSuccessSnackbar('Data Source Created Successfully');
        return res;
      } else {
        this.showErrorSnackbar('Error creating data source');
      }
      return res;
    } catch (e) {
      this.showErrorSnackbar(`Error creating data source: ${e}`);
    } finally {
      this.isCreatingDataSource = false;
    }
  }

  public filesChange(fieldName: string, fileList: any) {
    if (fileList.length === 1) {
      this.uploadData = fileList[0];
    }
  }

  // Someone needs to fill in support for all other transaction types
  // and also implement handlers in the back end
  public transactionTypes = [
    { label: 'All', id: 'all' },
    // { label: 'Trade', id: 'trade' },
    // { label: 'Categorized Internal transfer', id: 'categorizedInternalTransfer' },
  ];

  public allowReconciledModification = false;
  public allowCategorizedModification = false;

  // public wallets = this.$store.state.wallets.wallets;

  public get wallets() {
    const walletsArray = this.$store.state.wallets.wallets;
    if (walletsArray !== undefined && Array.isArray(walletsArray)) {
      if (walletsArray.length === 1) {
        this.selectedWallet = [walletsArray[0].id ?? ''];
      }
    }

    return walletsArray ? [{ id: 'All', name: 'All Wallets' }, ...walletsArray] : [];
  }

  public selectedAction = 'uncategorize';
  public selectedWallet: string[] = [];
  public selectedTransactionType = 'all';
  public startDate = '';
  public endDate = '';
  public dialog = false;
  public loading = false;
  public uploadProgress = 0;
  public uploadStatus = '';
  public isUploading = false;
  public uploadData = null;
  public dataSourceId = ``;
  public selectedResolution = 'accept';
  public selectedTransactionState = 'open-needs-review';
  public updateChildrenForExistingParent = false;
  public processNewTxns = true;
  public matchingCriteriaExpanded = false;
  public metadataExpanded = false;
  public matchFromAddress = '';
  public matchToAddress = '';
  public matchDirection = '';
  public matchToken = '';
  public matchMethodId = '';
  public matchMetadata: MetadataConditionValue = { operator: 'OR', metadata: [{ key: '', value: '' }] };

  public readonly matchDirections = [
    { id: '', label: 'Any direction' },
    { id: 'Inbound', label: 'Inbound' },
    { id: 'Outbound', label: 'Outbound' },
    { id: 'Empty', label: 'Empty' },
    { id: 'All', label: 'All' },
  ];

  public get supportsTransactionFilters() {
    return (
      this.checkFeatureFlag('system-job-transaction-matching-filters') &&
      ['delete', 'ignore', 'unignore', 'reconcile', 'markReconciled', 'markUnreconciled', 'uncategorize'].includes(
        this.selectedAction
      )
    );
  }

  private buildMatchCriteria() {
    if (!this.supportsTransactionFilters) return undefined;
    const metadata = this.matchMetadata.metadata
      .filter((pair) => pair.key.trim())
      .map((pair) => ({ key: pair.key.trim(), value: pair.value.trim() || undefined }));
    const criteria = {
      fromAddress: this.matchFromAddress.trim() || undefined,
      toAddress: this.matchToAddress.trim() || undefined,
      direction: this.matchDirection || undefined,
      tokens: this.matchToken.trim() ? [this.matchToken.trim()] : undefined,
      methodId: this.matchMethodId.trim() || undefined,
      metadataRule: metadata.length
        ? { operator: this.matchMetadata.operator, metadata, txnRecordRule: false }
        : undefined,
    };
    return Object.values(criteria).some((value) => value !== undefined) ? criteria : undefined;
  }

  public resolutionOptions = [
    { label: 'Accept', id: 'accept' },
    { label: 'Ignore', id: 'ignore' },
  ];

  public transactionStateOptions = [
    { label: 'Open Needs Review', id: 'open-needs-review' },
    { label: 'New Needs Review', id: 'new-needs-review' },
    { label: 'Closed Needs Review', id: 'closed-needs-review' },
  ];

  /** Actions whose backing system job cannot run without an explicit date range. */
  public get requiresDateRange() {
    return this.selectedAction === 'reprocessRollupParentTxns';
  }

  public get hasDateRange() {
    return (this.startDate ?? '').trim().length > 0 && (this.endDate ?? '').trim().length > 0;
  }

  /** True once every wallet is covered, either via 'All Wallets' or by picking each one. */
  public get allWalletsSelected() {
    const selected = this.selectedWallet ?? [];
    if (selected.includes('All')) {
      return true;
    }

    const selectable = this.wallets.filter((wallet) => wallet.id !== 'All');
    return selectable.length > 0 && selected.length >= selectable.length;
  }

  /**
   * Blank out the search prompt once there is nothing left to pick. Returning undefined
   * keeps UiSelect2's own default.
   */
  public get walletSearchPlaceholder() {
    return this.allWalletsSelected ? '' : undefined;
  }

  public get isRunDisabled() {
    if (this.requiresDateRange && !this.hasDateRange) {
      return true;
    }

    if (this.selectedAction === 'csvBulkAction' && this.dataSourceId && !this.isUploading) {
      return false;
    }

    return this.loading || this.selectedAction.length === 0 || this.selectedWallet.length === 0;
  }

  public async downloadCategorizeTemplate() {
    const columns = ['txnId', 'action'];
    const rows = ['delete', 'markReconciled', 'markUnreconciled', 'uncategorize', 'ignore', 'unignore', 'reconcile'];
    let csvContent = '"' + columns.join('","') + '"\n';
    rows.forEach((row) => {
      csvContent = csvContent + '"","' + row + '"\n';
    });
    downloadCsv(csvContent, 'CSV Bulk Action Template');
  }

  public async doUpload() {
    const res = await this.createDataSource();
    this.isUploading = true;
    this.uploadStatus = 'Uploading';
    this.dataSourceId = res?.data?.id ?? '';
    try {
      const ds = DataApiManager.getInstance();
      const loadDetails = await ds.createDataSourceLoad(this.orgId, this.dataSourceId, { withCredentials: true });
      if (loadDetails.status === 200) {
        // do Upload
        const config = {
          onUploadProgress: (progressEvent: any) => {
            this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 95);
            if (this.uploadProgress === 95) {
              this.uploadStatus = 'Wrapping up.';
            }
          },
        };
        await upload(this.uploadData, loadDetails.data.uploadUrl, config);
        const res = await ds.commitDataSourceLoad(this.orgId, this.dataSourceId, loadDetails.data.id, false, {
          withCredentials: true,
        });
        this.uploadProgress = 100;
        if (res.status === 200) {
          this.showSuccessSnackbar(this.$tc('_dataLoadSuccess'));
        } else {
          this.showErrorSnackbar(
            this.$tc('_dataLoadFailure') + `- ${res.data.message !== '' ? ' - ' + res.data.message : ''}`
          );
          throw new Error(`Commit Data Source load failed ${res.data.message}`);
        }
      } else {
        this.showErrorSnackbar(this.$tc('_dataLoadFailure') + `${loadDetails.data.message}`);
        throw new Error(`Create Data Source load failed ${loadDetails.data.message}`);
      }
    } catch (err) {
      this.showErrorSnackbar(this.$tc('_dataLoadFailure') + `${err}`);
      console.error(`Error creating data source load - ${err}`);
    } finally {
      this.isUploading = false;
      this.uploadProgress = 0;
      this.uploadStatus = '';
    }
  }

  public async runJob() {
    if (this.isRunDisabled) {
      return;
    }

    this.loading = true;

    let systemJobId = 'bulk-transaction';
    if (this.selectedAction === 'repriceFailedToPriceTransactions') {
      systemJobId = 'reprice-failed-to-price-transactions';
    } else if (this.selectedAction === 'processNeedsReviewTransactions') {
      systemJobId = 'process-needs-review-transactions';
    } else if (this.selectedAction === 'repricePricedAndReadyToPriceTransactions') {
      systemJobId = 'reprice-priced-and-ready-to-price-transactions';
    } else if (this.selectedAction === 'reprocessRollupParentTxns') {
      systemJobId = 'reprocess-rollup-parent-txns';
    }

    const walletIds = Array.isArray(this.selectedWallet) ? this.selectedWallet : [this.selectedWallet];
    // If 'All' is selected, set to undefined instead of passing 'All'
    const hasAllWallets = walletIds.includes('All');

    const promises = hasAllWallets
      ? [this.executeJobWithWallet(systemJobId, undefined)]
      : walletIds.map((walletId) => this.executeJobWithWallet(systemJobId, walletId));

    try {
      await Promise.all(promises);
      this.showSuccessSnackbar('Job started. Track its progress and status messages in the jobs list below.');
      this.$emit('refresh');
      this.dialog = false;
    } catch (e) {
      // Without this the rejected mutation left the modal spinning forever with no explanation.
      const message = stringifyError(e, { hideErrorName: true }).replace('GraphQL error: ', '');
      this.showErrorSnackbar(`Error running job - ${message}`);
      console.error(`Error running system job ${systemJobId} - ${message}`);
    } finally {
      this.loading = false;
    }
  }

  private async executeJobWithWallet(systemJobId: string, walletId?: string) {
    const vars = {
      orgId: this.$store.state.currentOrg.id,
      systemJobId,
      action: this.selectedAction,
      dataSourceId: this.dataSourceId,
      walletId: walletId,
      // Send undefined rather than '' so the backend sees an omitted date instead of a malformed one.
      startSEC: (this.startDate ?? '').trim() || undefined,
      endSEC: (this.endDate ?? '').trim() || undefined,
      transactionType: this.selectedTransactionType,
      allowReconciledModification: this.allowReconciledModification,
      allowCategorizedModification: this.allowCategorizedModification,
      resolution: this.selectedAction === 'processNeedsReviewTransactions' ? this.selectedResolution : undefined,
      transactionState:
        this.selectedAction === 'processNeedsReviewTransactions' ? this.selectedTransactionState : undefined,
      updateChildrenForExistingParent:
        this.selectedAction === 'reprocessRollupParentTxns' ? this.updateChildrenForExistingParent : undefined,
      processNewTxns: this.selectedAction === 'reprocessRollupParentTxns' ? this.processNewTxns : undefined,
      matchCriteria: this.buildMatchCriteria(),
    };

    return this.$apollo.mutate({
      mutation: gql`
        mutation (
          $orgId: ID!
          $systemJobId: String!
          $action: String!
          $walletId: String
          $startSEC: String
          $endSEC: String
          $dataSourceId: String
          $transactionType: String
          $allowReconciledModification: Boolean
          $allowCategorizedModification: Boolean
          $resolution: String
          $transactionState: String
          $updateChildrenForExistingParent: Boolean
          $processNewTxns: Boolean
          $matchCriteria: TransactionMatchCriteriaInput
        ) {
          runSystemJob(
            orgId: $orgId
            systemJobId: $systemJobId
            action: $action
            walletId: $walletId
            startSEC: $startSEC
            endSEC: $endSEC
            dataSourceId: $dataSourceId
            transactionType: $transactionType
            allowReconciledModification: $allowReconciledModification
            allowCategorizedModification: $allowCategorizedModification
            resolution: $resolution
            transactionState: $transactionState
            updateChildrenForExistingParent: $updateChildrenForExistingParent
            processNewTxns: $processNewTxns
            matchCriteria: $matchCriteria
          )
        }
      `,
      variables: vars,
    });
  }
}
